import { random } from "@ngneat/falso";
import { createNodeDef } from "../../nodes.helpers";

export const randomNodeDef = createNodeDef({
  type: "random",
  displayName: "Random",
  description: "Create a seed",
  initialData: () => ({}),
  generate: () => {
    return random();
  },
});
